class APIError {
  message: string = "";
  code: string = "";
}

export default APIError;
